import React from "react";
import { inject, observer } from "mobx-react";
import { Grid } from "@material-ui/core";
import { IManagementStore } from "Stores/Management/types";
import { observable, computed } from "mobx";
import { Values } from "@src/Tools/Values";
import STPageHeader from "@src/Components/Ui/STPageHeader";
import TableSearchInput from "@src/Components/Common/TableSearchInput/TableSearchInput";
import {
  ApplicationPermission,
  ApplicationPermissionExtendedFlat,
  ApplicationPermissionPosition,
  ApplicationPermissionPositionTeam,
} from "@src/Interfaces/Entity/ApplicationPermission";
import filterByTableColumns from "@src/Tools/filterByTableColumns";
import ResultsAreEmpty from "@src/Components/Ui/ResultsAreEmpty";
import ApplicationPermissionsTable from "./ApplicationPermissionsTable";
import { IValuesStore } from "Stores/Values/types";
import _ from "lodash";

interface IProps {
  management?: IManagementStore;
  values?: IValuesStore;
}

@inject("values", "management")
@observer
class ApplicationPermissionsContent extends React.Component<IProps> {
  @observable searchText: string = "";

  @computed get filteredPermissions() {
    var apps = this.GetApplications();

    var extendedPermissions = _.map(this.props.management.applicationPermissions, (permission) => {
      var app = _.find(apps, (x) => x.id == permission.application);
      var positionNames = _.map(permission.positions, (p) => {
        return {
          id: p.position,
          name: this.getPositionName(p),
        };
      });
      const positionTeamNames = _.map(permission.positionTeams, (p) => {
        return {
          id: p.positionTeam,
          name: this.getPositionTeamName(p),
        };
      });

      var extended: ApplicationPermissionExtendedFlat = {
        ...permission,
        applicationName: this.getName(app),
        organizationName: this.getOrganizationName(permission.organization),
        entityName: this.getName(permission.entity),
        permissionName: this.getName(permission.permission),
        positionNames: positionNames,
        positionTeamNames: positionTeamNames,
        callbackUrl: this.getCallbackUrl(app, permission),
      };

      _.each(positionNames, (x, i) => {
        extended["positionName-" + i] = x.name;
      });

      return extended;
    });

    return filterByTableColumns<ApplicationPermissionExtendedFlat>(extendedPermissions, this.searchText);
  }

  GetApplications(): { id: number; name: string }[] {
    return Object.entries(this.props.values.knownApplications).map((entry: [string, number]) => {
      const [name, id] = entry;
      return { name: name, id: id };
    });
  }

  getOrganizationName(organizationId: string): string {
    var organization = _.find(this.props.management.activeOrganisations, (x) => x.id == organizationId);
    return this.getName(organization);
  }

  getPositionName(position: ApplicationPermissionPosition): string {
    var activePositions = _.find(this.props.management.activePositions, (x) => x.id == position.position);
    let positionName = this.getName(activePositions);
    if (positionName && positionName !== Values.getLocalizationValue("notAvailableAcronym") && position.activeOnly) {
      positionName += ` (${Values.getLocalizationValue("active").toLowerCase()})`;
    }
    return positionName;
  }

  getPositionTeamName(positionTeam: ApplicationPermissionPositionTeam): string {
    var activePositionTeams = _.find(
      this.props.management.activePositionTeams,
      (x) => x.id == positionTeam.positionTeam
    );
    let positionTeamName = this.getName(activePositionTeams);
    if (
      positionTeamName &&
      positionTeamName !== Values.getLocalizationValue("notAvailableAcronym") &&
      positionTeam.activeOnly
    ) {
      positionTeamName += ` (${Values.getLocalizationValue("active").toLowerCase()})`;
    }
    return positionTeamName;
  }

  getName(model: { name: string }): string {
    return _.isNil(model) || _.isEmpty(model.name)
      ? Values.getLocalizationValue("notAvailableAcronym")
      : _.startCase(model.name);
  }

  getCallbackUrl(app: { id: number; name: string }, permission: ApplicationPermission): string {
    var appUrls = this.props.values.knownApplicationUrls;
    var appUrl = appUrls[app.name];
    var url = appUrl + _.trimStart(permission.relativeCallbackUrl, "/");
    return url;
  }

  handleChange = (event: any) => {
    this.searchText = event.target.value;
  };

  render() {
    return (
      <Grid container direction="column">
        <STPageHeader>{Values.getLocalizationValue("applicationPermissions")}</STPageHeader>
        <Grid container justify="space-between" alignItems="center" item>
          <Grid item>
            <TableSearchInput value={this.searchText} onChange={this.handleChange} />
          </Grid>
        </Grid>
        <Grid item xs>
          {this.filteredPermissions.length > 0 ? (
            <ApplicationPermissionsTable permissions={this.filteredPermissions} />
          ) : (
            <ResultsAreEmpty />
          )}
        </Grid>
      </Grid>
    );
  }
}

export default ApplicationPermissionsContent;
